import { render } from "./DatabaseQuestions.vue?vue&type=template&id=3ca4feb4&scoped=true"
import script from "./DatabaseQuestions.vue?vue&type=script&lang=js"
export * from "./DatabaseQuestions.vue?vue&type=script&lang=js"

import "./DatabaseQuestions.vue?vue&type=style&index=0&id=3ca4feb4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca4feb4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
